import React, {useState, useEffect, useRef} from 'react';
import {useRouter} from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import Link from 'next/link';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import RCAPage from './RCAPage';
import ErrorMessage from '../../elements/ErrorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheckCircle, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import LoadingFullPage from '../../elements/LoadingFullPage';
import { reset } from '../../login/userSlice';

const RCAList = (props) =>{
    
    const {showFilter} = props;
    const [isError, editIsError] = useState(false);
    const [isLoadingList, editIsLoadingList] = useState(true);
    const [page, editPage] = useState(1);
    const [rcaList, editRCAList] = useState([]);
    const [totalItems, editTotalItems] = useState(0);
    const [shownItems, editShownItems] = useState(0);

    const [hideExpired, editHideExpired] = useState(false);

    const router = useRouter();
    const user = useSelector(state => state.user );
    const itemsPerPage = 5;
    const isMounted = useRef(null);
    const dispatch = useDispatch();

    useEffect( ()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        }
    }, []);

    useEffect( ()=>{
        if (user.isLoggedIn){
            getList();
        }
    }, [user.isLoggedIn])

    useEffect( ()=>{
        if (page >1) {
            getList();   
        }
    }, [page])

    const toggleExpiration = (e) =>{
        editHideExpired(!hideExpired);
    }

    const filterHtml = showFilter &&
        <Col  xs={12} lg={8} className="py-2 text-left mx-auto" id="filterExpired">
            <Form.Check 
                type="switch"
                id="custom-switch"
                label="Ascunde ofertele expirate"
                onChange={toggleExpiration}
                checked={hideExpired}
            />
        </Col>;

    const listHtml = rcaList.map( item =>
        <RCAPage key={item.page} list={item.list} addToCart={true} hideExpired={hideExpired} />
    );

    const error = isError &&
        <Col xs={12}  className="mx-auto">
            <ErrorMessage title="Eroare" message={isError} />
        </Col>;

    const getList = async() =>{
        try {
            const response = await axios({
                method: 'get',
                url: process.env.NEXT_PUBLIC_API + '/api/user/asigurari/rca/oferte',
                params: {
                    items: itemsPerPage,
                    page: page,
                },
                withCredentials: true,
            });

            const data = response.data;
            if (isMounted.current) {
            
                if (data.status == 'success') {
                    let newPage = {
                        page: page,
                        list: data.list,
                    };
                    let newList = [...rcaList, newPage];
                    editRCAList(newList);
                    editTotalItems(data.items);
                    editShownItems(shownItems + data.list.length);
                } else if (data.status = 'login'){
                    dispatch(reset());
                } else {
                    editIsError('Ups, avem o eroare. Te rugăm să încerci mai tărziu.');
                }
                editIsLoadingList(false);
            }

        } catch (err){
            if (isMounted.current) {
                editIsLoadingList(false);
                editIsError('Ups, avem o eroare. Te rugăm să încerci mai tărziu.');
            }
        }
    }

    const loadMore = () =>{ editPage(page+1);}
    const moreOrders = 
        <Col xs={12} lg={8} className="text-center mx-auto">
            {(page * itemsPerPage < totalItems) ?
            <>
            <Button 
                className="mb-3" 
                onClick={loadMore} 
                disabled={isLoadingList ? true : false}
            >
                <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="mr-2" />
                Mai multe ({`${shownItems}/${totalItems}`})
            </Button>
            {showFilter && hideExpired && 
                <p>
                    <Link href="#filterExpired" passHref>
                        <small className="btn btn-link">Ofertele expirate sunt ascunse.</small>
                    </Link>
                </p>}
            </>
            :
            <p>Ai ajuns la finalul listei.</p>
            }
        </Col>
    ;

    return (
        isLoadingList ?
        <LoadingFullPage />
        :
        <Row>   
            {filterHtml}
            {listHtml}
            {moreOrders}
            {error}
        </Row>
    );
}

export default RCAList;